import {forwardRef} from 'react';
import {cn} from '../../../../../../lib/classname';
import {CommonLink} from '../../../../../../shared/components/CommonLink';
import {OutlineButton} from './Button';

export type TaxonomyItem = {
  name: string;
  href: string;
};
type Props = {
  className?: string;
  items: TaxonomyItem[];
  activeIndex?: number;
};

export const Taxonomies = forwardRef<HTMLDivElement, Props>(
  ({className, items, activeIndex}, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'overflow-x-auto',
          'pc:bg-white pc:shadow-inner pc:rounded-16 pc:py-12 pc:px-16',
          className,
        )}
      >
        <ul
          className={cn('flex flex-nowrap gap-8 items-center', 'px-16 pc:px-0')}
        >
          {items.map((item, index) => (
            <li key={item.href}>
              <OutlineButton
                as={CommonLink}
                href={item.href}
                active={index === activeIndex}
              >
                {item.name}
              </OutlineButton>
            </li>
          ))}
        </ul>
      </div>
    );
  },
);

Taxonomies.displayName = 'Taxonomies';
